import React from 'react'
import PageHeader from '../../Components/layout/PageHeader'

const Terms = () => {
  return (
    <div className='bg-black h-screen overflow-hidden overflow-y-scroll'>
      <PageHeader/>
    <div className='text-white m-3 '>
        <b>Terms and Conditions</b>
        <div className='text-sm mt-2'>
      <p>
        By using our service, you agree to comply with and be bound by the following terms and conditions of use. Please read these terms carefully before using our application.
      </p>
      <h6>Disclaimer</h6>
      <p>This project and its contents are not affiliated with, funded, authorized, endorsed by, or in any way associated with YouTube, Google LLC or any of its affiliates and subsidiaries.</p>
      <h6>Use of the Service</h6>
      <p>
        Our application provides collaborative music listening features that allow users to listen to music together with friends while using notification permissions for playing songs in the background. By using our service, you agree to abide by these terms and any additional guidelines or rules provided by us.
      </p>
      <h6>User Accounts</h6>
      <p>
        We use Google auth to create user account. We won't read, share or store any user's personal informations like name, email, password, age, gender, phone number or other informations in our database. We save your personal informations in your browser cookies for reliable service. We never track or read your  cookies.
      </p>
      <h6>Privacy Policy</h6>
      <p>
        Our privacy practices are described in our Privacy Policy, which governs your use of our service. Please review our Privacy Policy carefully to understand how we collect, use, and disclose your personal information.
      </p>
      <h6>Intellectual Property</h6>
      <p>
      Any trademark, service mark, trade name, or other intellectual property rights used in this project are owned by the respective owners
      </p>
      <h6>Limitation of Liability</h6>
      <p>
        We strive to provide a reliable and secure service, but we cannot guarantee that our application will be uninterrupted or error-free. We are not liable for any damages arising from the use or inability to use our service, including but not limited to direct, indirect, incidental, or consequential damages.
      </p>
      {/* <h6>Governing Law</h6>
      <p>
        These terms and conditions are governed by and construed in accordance with the laws of [Your Jurisdiction]. Any disputes relating to these terms shall be subject to the exclusive jurisdiction of the courts of [Your Jurisdiction].
      </p> */}
      {/* <h6>Changes to Terms</h6>
      <p>
        We reserve the right to modify or update these terms of service at any time. Any changes will be effective immediately upon posting to our website or application. Your continued use of our service after any such changes constitutes acceptance of the updated terms.
      </p> */}
      <h6>Contact Us</h6>
      <p>
        If you have any questions or concerns about these terms of service, please contact us at rajadeepak1989@gmail.com.
      </p>
      </div>
    </div>
    </div>
  )
}

export default Terms